"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UsernameVariableWithoutSpaceNode = exports.UsernameVariableNode = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UsernameVariableWithoutSpaceNode = "<input-variable contenteditable=false type='username'>username</input-variable>";
exports.UsernameVariableWithoutSpaceNode = UsernameVariableWithoutSpaceNode;
var UsernameVariableNode = "".concat(UsernameVariableWithoutSpaceNode, "&nbsp;");
exports.UsernameVariableNode = UsernameVariableNode;

var EditableInputWithVariable = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EditableInputWithVariable, _Component);

  var _super = _createSuper(EditableInputWithVariable);

  function EditableInputWithVariable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EditableInputWithVariable);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "contentEditable", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastHtml", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onKeyDown", function (e) {
      // prevents line breaks
      if (e.key === 'Enter') {
        e.preventDefault();
      }

      if (window.getSelection && e.key === 'Backspace') {
        // backspace
        // fix backspace bug in FF
        // https://bugzilla.mozilla.org/show_bug.cgi?id=685445
        var selection = window.getSelection();

        if (!(selection !== null && selection !== void 0 && selection.isCollapsed) || !selection.rangeCount) {
          return;
        }

        var curRange = selection.getRangeAt(selection.rangeCount - 1);

        if (curRange.commonAncestorContainer.nodeType === 3 && curRange.startOffset > 0) {
          // we are in child selection. The characters of the text node is being deleted
          return;
        }

        var range = document.createRange();

        if (_this.contentEditable === null) {
          return;
        }

        if (selection.anchorNode !== _this.contentEditable) {
          // selection is in character mode. expand it to the whole editable field
          range.selectNodeContents(_this.contentEditable);

          if (selection.anchorNode) {
            range.setEndBefore(selection.anchorNode);
          }
        } else if (selection.anchorOffset > 0) {
          range.setEnd(_this.contentEditable, selection.anchorOffset);
        } else {
          // reached the beginning of editable field
          return;
        }

        if (_this.contentEditable) {
          range.setStart(_this.contentEditable, range.endOffset - 1);
        }

        var previousNode = range.cloneContents().lastChild;

        if (previousNode) {
          // this is some rich content, e.g. smile. We should help the user to delete it
          range.deleteContents();
          e.preventDefault();
        }
      }

      _this.emitChange();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveCursorPosition", function () {
      var selection = window.getSelection();

      if (selection !== null && selection !== void 0 && selection.rangeCount) {
        _this.setState({
          cursorPosition: selection.getRangeAt(0)
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "inserVariable", function (node) {
      var cursorPosition = _this.state.cursorPosition;
      if (!cursorPosition) return;
      var selection = window.getSelection();
      selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
      selection === null || selection === void 0 ? void 0 : selection.addRange(cursorPosition);
      cursorPosition.deleteContents();
      cursorPosition.insertNode(cursorPosition.createContextualFragment(node));
      cursorPosition.collapse(false);

      _this.emitChange();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "emitChange", function () {
      if (_this.contentEditable === null) {
        return;
      }

      var innerHTML = _this.contentEditable.innerHTML;

      if (_this.props.onChange && innerHTML !== _this.lastHtml) {
        _this.props.onChange(innerHTML);
      }

      _this.lastHtml = innerHTML;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "shouldComponentUpdate", function (nextProps) {
      var _this$contentEditable;

      return nextProps.value !== ((_this$contentEditable = _this.contentEditable) === null || _this$contentEditable === void 0 ? void 0 : _this$contentEditable.innerHTML);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function () {
      if (_this.contentEditable === null) {
        return;
      }

      var value = _this.props.value;
      var innerHTML = _this.contentEditable.innerHTML;

      if (value !== innerHTML) {
        _this.contentEditable.innerHTML = value;
      }
    });
    _this.state = {
      cursorPosition: null,
      isFocused: false
    };
    return _this;
  }

  (0, _createClass2.default)(EditableInputWithVariable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          customClass = _this$props.customClass,
          value = _this$props.value,
          maxLength = _this$props.maxLength,
          error = _this$props.error;
      var isFocused = this.state.isFocused;
      return (0, _preact.h)("div", {
        className: "editable-input-with-variable"
      }, (0, _preact.h)("div", {
        className: "input-wrapper"
      }, (0, _preact.h)("div", {
        ref: function ref(_ref) {
          _this2.contentEditable = _ref;
        },
        contentEditable: true,
        onInput: this.emitChange,
        onBlur: function onBlur() {
          return _this2.saveCursorPosition();
        },
        onKeyDown: this.onKeyDown,
        onKeyPress: function onKeyPress(e) {
          if (!maxLength) {
            return;
          }

          if (_this2.contentEditable === null) {
            return;
          }

          if (_this2.contentEditable.innerText.length >= maxLength) {
            e.preventDefault();
          }
        },
        onPaste: function onPaste(e) {
          var _this2$contentEditabl, _this2$contentEditabl2;

          if (!maxLength) return;
          var paste = (e.clipboardData || window.clipboardData).getData('text');
          var currentText = (_this2$contentEditabl = (_this2$contentEditabl2 = _this2.contentEditable) === null || _this2$contentEditabl2 === void 0 ? void 0 : _this2$contentEditabl2.innerText) !== null && _this2$contentEditabl !== void 0 ? _this2$contentEditabl : '';

          if (currentText.length + paste.length >= maxLength) {
            e.preventDefault();
          }
        },
        className: (0, _classnames.default)(customClass, 'content-editable', {
          error: error
        }),
        dangerouslySetInnerHTML: {
          __html: value
        }
      }), (0, _preact.h)(_DropdownControl.default, {
        newStyle: true,
        triggerClass: (0, _classnames.default)('variable-dropdown', {
          focused: isFocused
        }),
        align: "right",
        trigger: (0, _preact.h)(_assets.default, {
          icon: "variable"
        }),
        items: [{
          groupName: 'Recipient attributes',
          items: [{
            title: 'User name',
            value: 'username',
            onClick: function onClick() {
              return _this2.inserVariable(UsernameVariableNode);
            }
          }]
        }]
      })));
    }
  }]);
  return EditableInputWithVariable;
}(_preact.Component);

var _default = EditableInputWithVariable;
exports.default = _default;